export interface OptionsType {
  label: string;
  value: number | string;
}
export const getVendorsForProduct = (data: any) => {
  let convertedData = [] as OptionsType[];
  data &&
    data?.forEach((item: any) => {
      let selectOptions = {} as OptionsType;
      selectOptions.label = item.vendorName;
      selectOptions.value = item.vendorName;

      convertedData.push(selectOptions);
    });

  return convertedData?.sort((a, b) => a.label.localeCompare(b.label));
};
